const ENABLE_MODALS = 'ENABLE_MODALS';
const CURBSIDE_CONCIERGE_INFO_MODAL = 'CURBSIDE_CONCIERGE_INFO_MODAL';

const SOURCE_MODALS = {
    SIGN_IN: 'signIn',
    SIGN_IN_WITH_MESSAGING: 'signInWithMessaging',
    SIGN_IN_WITH_AUTHENTICATE: 'signInWithAuthenticate'
};

export {
    ENABLE_MODALS, CURBSIDE_CONCIERGE_INFO_MODAL, SOURCE_MODALS
};
